module.exports={
    zh:{
         userType:"人员类型",
         registerPhoto:"注册照片",
         auth:"授权",
         userName:"人员姓名",
         appName:"应用名",
         device:"授权设备",
         cardNo:"卡号",
         photo:"照片",
         useDeviceTakePhoto:"使用设备拍照",
         submit:"确定",

    },
    en:{
        userType:"User Type",   
        registerPhoto:"Register Photo",
        auth:"Authorization",
        userName:"User Name",
        appName:"App Name",
        device:"Device",
        cardNo:"Card No",
        photo:"Photo",
        useDeviceTakePhoto:"use device take photos",
        submit:"submit",
    } 
}


// WEBPACK FOOTER //
// ./src/components/i18n/lang/attendance.js